import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useTranslate, useCurrentUser, useShallowEqualSelector } from '@hooks';
import { createUpload, importStat } from '@actions';
import { uploadTypes } from '@dotone/react-ui-core/constants';
import Trans from 'next-translate/Trans';
import { Row, Col } from 'reactstrap';
import { Label, FileUploader, Spinner, Alert, UploadSummaryModal } from '@dotone/react-ui-core';

const UploadCSVTab = ({ setActiveTab }) => {
  const { t, tHtml } = useTranslate('stat', 'pages.upload');

  const router = useRouter();
  const dispatch = useDispatch();
  const [creating, setCreating] = useState(false);
  const [summaryOpen, setSummary] = useState(false);
  const { currentUser } = useCurrentUser();

  const {
    isLoading,
    status,
    data: upload,
  } = useShallowEqualSelector(({ uploadCreate }) => uploadCreate);
  const { status: importStatus, isLoading: importIsLoading } = useShallowEqualSelector(
    ({ statImport }) => statImport
  );

  const handleUploadSucess = ({ key }) => {
    if (key) {
      setCreating(true);
      dispatch(
        createUpload({
          fileKey: key,
          descriptions: uploadTypes.OFFER_CONVERSION_UPLOAD,
        })
      );
    }
  };

  const handleToggle = () => {
    setSummary(!summaryOpen);
  };

  const handleImportUpload = () => {
    dispatch(importStat({ uploadId: upload.id }));
  };

  useEffect(() => {
    if (importStatus === 'success' && !importIsLoading && summaryOpen) {
      setSummary(false);
      router.push('/advertisers/uploads');
    }
  }, [router, importStatus, importIsLoading, summaryOpen]);

  useEffect(() => {
    if (creating && status === 'success' && upload.large) {
      setCreating(false);
      router.push(`/advertisers/uploads`);
    }
  }, [status, creating, router, upload.large]);

  useEffect(() => {
    if (creating && status === 'success' && !isLoading && !upload.large) {
      setSummary(true);
    }
  }, [setSummary, creating, status, isLoading, upload.large]);

  if (!currentUser.id || isLoading) {
    return <Spinner />;
  }

  return (
    <Row>
      <Col sm={12}>
        <Alert variant="warning">
          <Trans
            i18nKey="stat:pages.upload.instructions"
            components={[
              <a
                onClick={() => setActiveTab('multiPoint')}
                key="order"
                className="text-underline"
              />,
              <a
                onClick={() => setActiveTab('singlePoint')}
                key="lead"
                className="text-underline"
              />,
            ]}
          />
          {tHtml('note')}
        </Alert>
      </Col>
      <Col sm={12} className="mb-2">
        <Label>{t('uploadCsv')}</Label>
      </Col>
      <Col sm={12}>
        <FileUploader entity="upload" isPublic={false} onSuccess={handleUploadSucess} />
        <UploadSummaryModal
          isOpen={summaryOpen}
          onToggle={handleToggle}
          upload={upload}
          onSubmit={handleImportUpload}
          submitting={importIsLoading}
        />
      </Col>
    </Row>
  );
};

export default UploadCSVTab;
